import * as React from 'react'
import { connect } from 'react-redux'
import { TextArea } from 'src/elements'
import { Dispatch, RootState } from 'src/store'
import styled from 'styled-components'

type IDiscussionInputProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>

const StyledTextArea = styled(TextArea)`
  height: 44px;
  resize: none;
  outline: none !important;
  &:focus {
    outline: none !important;
  }
`

const DiscussionInput = ({
  text,
  isAutoFocus,
  onInputChange
}: IDiscussionInputProps) => {
  return (
    <StyledTextArea
      ref={ref => ref && isAutoFocus && ref.focus()}
      placeholder="留言..."
      value={text}
      onChange={onInputChange}
    />
  )
}

const mapState = ({ discussion }: RootState) => ({
  isAutoFocus: discussion.replyId !== null,
  text: discussion.text
})

const mapDispatch = (dispatch: Dispatch) => ({
  onInputChange: (e: React.FormEvent<HTMLTextAreaElement>) => {
    dispatch.discussion.updateState({ text: e.currentTarget.value })
  }
})

export default connect(
  mapState,
  mapDispatch
)(DiscussionInput)



// WEBPACK FOOTER //
// ./src/components/MaterialDiscussion/DiscussionInput.tsx